import { YearsKnowingColumbusEntity } from '../entities/years-knowing-columbus-entity';

export default class State {
  items: Array<YearsKnowingColumbusEntity> = [];

  loaded = false;
}
